// Frontend service for tenant-defined custom user attributes (#267).
// Matches the shape of ../services/groups.js.
import api from './api'

export const userAttributesService = {
  // List attribute definitions. Admins get every definition (active +
  // archived); non-admins get only active, non-hidden ones (enforced
  // server-side).
  async list() {
    try {
      const response = await api.get('/user-attributes')
      return response.data?.attributes || []
    } catch (error) {
      console.error('Error listing user attributes:', error)
      throw error
    }
  },

  // Create a new attribute definition. key + type are immutable afterwards.
  async create(payload) {
    try {
      const response = await api.post('/user-attributes', payload)
      return response.data
    } catch (error) {
      console.error('Error creating user attribute:', error)
      throw error
    }
  },

  // Update an existing attribute definition (label/helpText/options/visibility/displayOrder).
  async update(key, updates) {
    try {
      const response = await api.put(`/user-attributes/${key}`, updates)
      return response.data
    } catch (error) {
      console.error('Error updating user attribute:', error)
      throw error
    }
  },

  // Activate an archived attribute definition.
  async activate(key) {
    try {
      const response = await api.post(`/user-attributes/${key}/activate`)
      return response.data
    } catch (error) {
      console.error('Error activating user attribute:', error)
      throw error
    }
  },

  // Deactivate (archive) an attribute definition.
  async deactivate(key) {
    try {
      const response = await api.post(`/user-attributes/${key}/deactivate`)
      return response.data
    } catch (error) {
      console.error('Error deactivating user attribute:', error)
      throw error
    }
  },
}

export default userAttributesService
